module.exports = __webpack_public_path__ + "static/media/Eaternity.b4dbb7c5.svg";